import { MSG_AUTH_EXPIRE } from '../../constants/constants';
import { isCurrent } from '../local-storage';

import { requestWrapper } from './reusable';

const config = require('../../config')();

// Local request helper for the store-data-validation endpoints that need
// the HTTP status preserved on thrown errors (e.g. to branch on 404).
// Mirrors `requestWrapper` but attaches `statusCode` to the error so
// callers can reliably detect "not found" responses whose bodies do not
// echo the status.
const statusAwareGet = async (token, resource) => {
  if (!isCurrent()) throw new Error(MSG_AUTH_EXPIRE);
  const url = new URL(config.rosHost + resource);
  const response = await fetch(url, {
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    method: 'GET',
  });
  if (!response.ok) {
    const errorBody = await response.json().catch(() => ({ message: response.statusText }));
    const errorToThrow = (errorBody && typeof errorBody === 'object')
      ? errorBody
      : { message: String(errorBody) };
    errorToThrow.statusCode = errorToThrow.statusCode ?? response.status;
    throw errorToThrow;
  }
  return { body: await response.json() };
};

export const productGet = (token, locationId) => statusAwareGet(
  token,
  `${config.storeDataValidationProductResource}/${locationId}`,
);

export const taxGet = (token, locationId) => statusAwareGet(
  token,
  `${config.storeDataValidationTaxResource}/${locationId}`,
);

export const activePromotionsGet = (token, locationId) => requestWrapper(
  token,
  `${config.storeDataValidationActivePromotionsResource}/${locationId}/active-promotions`,
  'get',
);

export const submitReportJob = (token, { country, reportType, storeId }) => {
  const body = { reportType };
  if (storeId) body.storeId = storeId;
  if (country) body.country = country;
  return requestWrapper(
    token,
    config.storeDataValidationReportJobsResource,
    'post',
    undefined,
    body,
  );
};

export const getReportJobStatus = (token, jobId) => requestWrapper(
  token,
  `${config.storeDataValidationReportJobsResource}/${jobId}`,
  'get',
);

export const getInventoryDetailsDownload = (token, country) => requestWrapper(
  token,
  `${config.storeDataValidationReportInventoryDetailsResource}/${country}`,
  'get',
);
